import { render, staticRenderFns } from "./schoolDetails.vue?vue&type=template&id=17be2567&scoped=true"
import script from "./schoolDetails.vue?vue&type=script&lang=js"
export * from "./schoolDetails.vue?vue&type=script&lang=js"
import style0 from "./schoolDetails.vue?vue&type=style&index=0&id=17be2567&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17be2567",
  null
  
)

export default component.exports